export const { REACT_APP_API_BASE: API_BASE, REACT_APP_STRIPE_PK: STRIPE_KEY } = process.env;
// export const { REACT_APP_PRODUCT_IMAGE_BASE_PATH: PRODUCT_IMAGE_BASE_PATH } = process.env;
// export const { PUBLIC_URL } = process.env;


